import React from 'react'
import { Theme } from 'features/ui/types'
import styled from 'styled-components'
import { useDisplayTheme } from 'hooks/useUiState'
import { AutomationId } from 'utils/automationUtil'
import {
  StyledHeaderContainer,
  StyledContainer,
  StyledContentContainer,
  StyledHeaderRight,
  StyledIconContainer,
  StyledContent,
  StyledActionContainer
} from './index.css'

const StyledNoHeaderContent = styled(StyledContent)`
  flex-grow: 1;
`

const DateTimeContainer = styled(StyledHeaderRight)`
  min-width: fit-content;
`

type CompactVocSoundbiteNoHeaderFrameProps = {
  dateItem: React.ReactNode
  domainIcon: React.ReactElement
  internalContents: React.ReactNode
  avatar: React.ReactNode
  serialNumber: number
  actionItems: React.ReactNode
}

const CompactVocSoundbiteNoHeaderFrame = ({
  dateItem,
  domainIcon,
  internalContents,
  actionItems,
  avatar,
  serialNumber
}: CompactVocSoundbiteNoHeaderFrameProps) => {
  const theme = useDisplayTheme() as Theme

  return (
    <StyledContainer
      mode={theme}
      data-testid={`${AutomationId.compactSoundbiteDefaultFrame.post}-${serialNumber}`}>
      {avatar}
      <StyledContentContainer>
        <StyledHeaderContainer>
          <StyledNoHeaderContent mode={theme}>{internalContents}</StyledNoHeaderContent>
          <DateTimeContainer mode={theme}>
            {dateItem}
            <StyledIconContainer>{domainIcon}</StyledIconContainer>
          </DateTimeContainer>
        </StyledHeaderContainer>
        {actionItems && <StyledActionContainer>{actionItems}</StyledActionContainer>}
      </StyledContentContainer>
    </StyledContainer>
  )
}

export default CompactVocSoundbiteNoHeaderFrame
